import { Modal } from "antd";
import PrimaryButton from "modules/SubComponents/Buttons/PrimaryButton";
import SecondaryButton from "modules/SubComponents/Buttons/SecondaryButton";
import React from "react";

export default function DeletePackageModal({
  open,
  onCancel,
  action,
  loading,
}) {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={
        <div className={"d-flex justify-center"}>
          <SecondaryButton buttonName={"Cancel"} onClick={onCancel} />
          <PrimaryButton
            buttonName={"Delete"}
            onClick={action}
            loading={loading}
          />
        </div>
      }
    >
      <div className="popups-msg ">
        Are you sure you want to delete this package? This action cannot be
        undone.
      </div>
    </Modal>
  );
}
